import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QuickActions = () => {
  const navigate = useNavigate();

  const quickActions = [
    {
      title: "Add New Product",
      description: "Create a new product in your catalog",
      icon: "Plus",
      color: "primary",
      action: () => navigate('/product-management'),
      buttonText: "Add Product"
    },
    {
      title: "Add Employee",
      description: "Invite a new team member to your organization",
      icon: "UserPlus",
      color: "success",
      action: () => navigate('/employee-management'),
      buttonText: "Add Employee"
    },
    {
      title: "View Reports",
      description: "Access detailed analytics and reports",
      icon: "BarChart3",
      color: "warning",
      action: () => {
        // Mock action for reports
        console.log("Navigate to reports");
      },
      buttonText: "View Reports"
    },
    {
      title: "Settings",
      description: "Manage your account and preferences",
      icon: "Settings",
      color: "secondary",
      action: () => navigate('/user-profile-settings'),
      buttonText: "Open Settings"
    }
  ];

  const getColorClasses = (color) => {
    const colors = {
      primary: "bg-primary/10 text-primary border-primary/20",
      success: "bg-success/10 text-success border-success/20",
      warning: "bg-warning/10 text-warning border-warning/20",
      secondary: "bg-secondary/10 text-secondary border-secondary/20"
    };
    return colors[color] || colors.primary;
  };

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold text-foreground">Quick Actions</h3>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {quickActions.map((action, index) => (
          <div key={index} className="bg-card border border-border rounded-lg p-6 micro-animation hover:shadow-sm">
            <div className="flex items-start space-x-4">
              <div className={`w-12 h-12 rounded-lg flex items-center justify-center border ${getColorClasses(action.color)}`}>
                <Icon name={action.icon} size={24} />
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="text-sm font-semibold text-foreground mb-1">{action.title}</h4>
                <p className="text-xs text-muted-foreground mb-3">{action.description}</p>
                <Button
                  variant="outline"
                  size="sm"
                  onClick={action.action}
                  className="micro-animation"
                >
                  {action.buttonText}
                </Button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;